import RagnaDataTable from '../ReactComponents/RagnaDataTable'; 
import RagnaModal from '../ReactComponents/RagnaModal'; 
import { ajax_api, getAccess } from '../../Globals';
import { useOutletContext } from 'react-router-dom';
import { useState } from 'react';
import { RMultiTab } from '../ReactComponents/RMultiTab';
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';

const AccountsManager = props => {
    const [refreshTable] = useOutletContext();
    const [thisTblRefresh, setThisTblRefresh] = useState(-999);
    const { register, handleSubmit, reset } = useForm();
    const { register: registerReset, reset: resetPassReset, handleSubmit: submitResetPass, formState: { errors } } = useForm();

    //datatable options
    const table_columns = [
        { display: "ID", col: "Id" },
        { display: "Active", col: "Active", customValue: e => e.Active ? <i className='fa fa-check' /> : <i className='fa fa-times' />, dontOrder: true },
        { display: "Full Name", col: "FullName" },
        { display: "Login ID", col: "LoginId" },
        //{ display: "Position", col: "Position" },
        { display: "Role", col: "Role" },
        //Role = _item.GroupName.FullName,
        //{ display: "Updated", col: "IsOld", customValue: e => e.IsOld ? <i className='fa fa-check' /> : <i className='fa fa-times' />, dontOrder: true },
        //{ display: "Last Login", col: "LastLogin" },
        //{
        //    display: "Category", col: "ActivityCategory", customValue: e => e.Name ?? "[No Category]", dontOrder: true
        //}
    ];
    const search_columns = [
        { display: "Activity", col: "FullName" },
    ];

    const [modalOpen, setModalOpen] = useState(false);

    const onSubmit = (d, url, isReset = false) => {
        var f = new FormData();
        Object.keys(d).forEach(dd => f.append(dd, Array.isArray(d[dd]) ? d[dd][0] : d[dd] ));

        axios.post(url, f, {withCredentials: true}).then(_ => {
            setModalOpen(false);
            setThisTblRefresh(r => r + 1);
            var msg = "Successfully edited User Account data";
            if (isReset) msg = "Successfully reset password";

            alert(msg)
        }).catch(console.log)
    }

    const [roles, setRoles] = useState([]);

    useEffect(_ => {
        //set roles option
        axios.get(`${ajax_api}users/get-roles`, { withCredentials: true }).then(r => setRoles(r.data))
        .catch(e => console.log(`${e}`))
    }, []);

    return <>
        <Helmet>
            <title>LTS | User Accounts Management</title>
        </Helmet>
        <RagnaModal
            noBtn={true}
            setModalOpen={setModalOpen}
            modalOpen={modalOpen}
            width={500}
            title="Manage user data"
            body={<>
                <RMultiTab
                    contents={
                        [
                            {
                                hideIf: !getAccess(13),
                                title: "User Details", content:
                                    <form onSubmit={
                                            handleSubmit(d => onSubmit(d, `${ajax_api}users/edit-user`))
                                        }>
                                        <input type="hidden" {...register("Id")} />
                                        Full Name:
                                        <input className="form-control" {...register("FullName")} />
                                        Role:
                                            <select className="form-select mb-2" {...register("UserRoleId")}>
                                                {
                                                    roles.map(r => <option value={r.value}>{r.label}</option>)
                                                }
                                        </select>
                                        <div className="d-flex">
                                            <input {...register("Active")} className="form-check-input me-2" type="checkbox" id={`check-Active`} />
                                            <label className="form-check-label" htmlFor={`check-Active`} >
                                                Account Active
                                            </label>
                                        </div>
                                            <button className="ro-button mt-2">
                                                <span>Save</span>
                                            </button>
                                        </form> 
                            },
                            {
                                hideIf: !getAccess(88),
                                title: "Reset Password", content:<form onSubmit={
                                    submitResetPass(d =>
                                        onSubmit(d, `${ajax_api}users/reset-pass`, true))}>
                                    <input type="hidden" {...register("Id")} />
                                    Temporary Password:
                                    <input type="password" className="form-control" {...registerReset("Password", {
                                        required: "This field is required",
                                        minLength: {
                                            value: 8,
                                            message: "Minimum of 8 characters for password"
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-zA-Z].*)(?=.*\d+.*)(?=.*[!@#\$%\^\&*\)\(+=._-].*).*$/g,
                                            message: "Password should have a special character, a number, and a letter"
                                        }
                                    })} />
                                    <ErrorMessage errors={errors} name="Password"
                                        render={({ message }) => <p className="text-danger m-0">{message}</p>} />
                                    <button className="ro-button mt-2">
                                        <span>Save</span>
                                    </button>
                                </form>
                            }
                        ]
                    }
                />
            </>}
        />
        <RagnaDataTable
            //draw={draw}
            customEntrySizes={[10, 50, 100, 1000]}
            refreshTable={refreshTable + thisTblRefresh}
            title="Roles Management Datatable"
            columns={table_columns}
            s_columns={search_columns}
            defaultOrder={true}
            maxPagination={8}
            generalSearch={true}
            defaultOrderCol="Id"
            url={`${ajax_api}users/get-list`}
            actions={[
                {
                    hideIf: !getAccess(88) && !getAccess(13),
                    component: d => <>
                        <button className="ro-button" onClick={_ => {
                            setModalOpen(true);
                            reset(d.data)
                            resetPassReset({ Id: d.data.Id, Password: ""})
                        }}>
                            <span>Manage</span>
                        </button>
                    </>,
                },
                //{
                //    action: "url_confirm", display: "Delete",
                //    content: d => `${DELETE_URL}?id=${d.ID}`,
                //    body: d => `Are you sure you want to delete 'Activity': ${d.FullName} ?`, title: "Delete Data"
                //},
            ]}
        />
    </>;
}

export default AccountsManager;